"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDsk = void 0;
/**
 * A Z-Wave DSK in its canonical form: 8 groups of exactly 5 digits, each
 * 0..65535, joined by '-'. Accepts that form, 40 bare digits or 8
 * space-separated groups, with surrounding whitespace; anything else (a short
 * group, 'unknown', 'auto-generated', null, ...) is null. The hub firmware's
 * `normalize_dsk` takes the same table, so both ends store and compare one form.
 */
function normalizeDsk(raw) {
    if (typeof raw !== 'string')
        return null;
    const trimmed = raw.trim();
    const groups = /^\d{40}$/.test(trimmed) ? trimmed.match(/\d{5}/g) : trimmed.split(/[-\s]/);
    const valid = groups.length === 8 && groups.every((group) => /^\d{5}$/.test(group) && Number(group) <= 65535);
    return valid ? groups.join('-') : null;
}
exports.normalizeDsk = normalizeDsk;
